module.exports = {
  "images": {
    "directUploads": true
  },
  "api": {},
  "project": {}
}



//////////////////
// WEBPACK FOOTER
// ./config/@sanity/form-builder.json?sanityPart=config%3A%40sanity%2Fform-builder
// module id = 999
// module chunks = 0